__turbopack_context__.v({
  "accordionSlideOverwrite": "command-module-scss-module__qYoajW__accordionSlideOverwrite",
  "command": "command-module-scss-module__qYoajW__command",
  "commandDialogContent": "command-module-scss-module__qYoajW__commandDialogContent",
  "commandEmpty": "command-module-scss-module__qYoajW__commandEmpty",
  "commandGroup": "command-module-scss-module__qYoajW__commandGroup",
  "commandInput": "command-module-scss-module__qYoajW__commandInput",
  "commandInputWrapper": "command-module-scss-module__qYoajW__commandInputWrapper",
  "commandItem": "command-module-scss-module__qYoajW__commandItem",
  "commandList": "command-module-scss-module__qYoajW__commandList",
  "commandSeparator": "command-module-scss-module__qYoajW__commandSeparator",
  "commandShortcut": "command-module-scss-module__qYoajW__commandShortcut",
  "fadeIn": "command-module-scss-module__qYoajW__fadeIn",
  "fadeOut": "command-module-scss-module__qYoajW__fadeOut",
  "scaleIn": "command-module-scss-module__qYoajW__scaleIn",
  "scaleOut": "command-module-scss-module__qYoajW__scaleOut",
  "zoomIn": "command-module-scss-module__qYoajW__zoomIn",
  "zoomOut": "command-module-scss-module__qYoajW__zoomOut",
});
